let isInitialized = false;

function getCurrentPlatform() {
  if (window.AppState && window.AppState.isTrueVRMode) return "VR";
  if (window.AppState && window.AppState.isPseudoVRMode) return "desktopVR";
  if (window.AppState && window.AppState.isDesktopMode) return "desktop";
  return "desktop";
}

document.addEventListener('DOMContentLoaded', function() {
  if (__LOG_INFO__) AppLog.info('Exact Center Panel page loaded');
  initializeApp();
});
async function initializeApp() {
  try {
    const scene = document.querySelector('a-scene');
    scene.addEventListener('loaded', async () => {
      if (__LOG_INFO__) AppLog.info('A-Frame scene loaded');
      setTimeout(async () => {
        await initializeCenterPanel();
      }, 1000);
    });

  } catch (error) {
    if (__LOG_ERROR__) AppLog.error('Failed to initialize app:', error);
    updateStatus('Initialization failed: ' + error.message);
  }
}

async function initializeCenterPanel() {
  try {
    updateStatus('Initializing center panel...');
    await loadOriginalData();

    isInitialized = true;
    updateStatus('Ready');
    updateLastUpdate();

    if (__LOG_INFO__) AppLog.info('Center panel initialized successfully');

    const scene = document.querySelector('a-scene');
    if (scene) {
      if (__LOG_INFO__) AppLog.info('[CenterPanel] Emitting center-panel-initialized to scene');
      scene.emit('center-panel-initialized');
    }
    if (__LOG_INFO__) AppLog.info('[CenterPanel] Dispatching center-panel-initialized to document');
    document.dispatchEvent(new CustomEvent('center-panel-initialized', {
      detail: { timestamp: Date.now() }
    }));

  } catch (error) {
    if (__LOG_ERROR__) AppLog.error('Failed to initialize center panel:', error);
    updateStatus('Center panel init failed: ' + error.message);

    const scene = document.querySelector('a-scene');
    if (scene) {
      scene.emit('center-panel-initialized');
    }
    document.dispatchEvent(new CustomEvent('center-panel-initialized'));
  }
}

async function loadOriginalData() {
  try {
    updateStatus('Loading original data...');
    const content = document.getElementById('large-center-panel-content');
    content.innerHTML = '';

    content.setAttribute('position', '0 0 0');

    setInitialChartType()

    updateStatus('Original data loaded');
    updateLastUpdate();

    if (__LOG_INFO__) AppLog.info('Original data loaded successfully');

  } catch (error) {
    if (__LOG_ERROR__) AppLog.error('Failed to load original data:', error);
    updateStatus('Data load failed: ' + error.message);

    const content = document.getElementById('large-center-panel-content');
    content.innerHTML = `
                    <a-text value="Error loading data:\n${error.message}" 
                            position="0 0 0.01" 
                            color="#ff4444" 
                            align="center" 
                            width="1.8">
                    </a-text>
                `;
  }
}

function refreshData() {
  if (!isInitialized) {
    if (__LOG_WARN__) AppLog.warn('App not yet initialized');
    return;
  }

  loadOriginalData();
}

function toggleEnvironment() {
  const env = document.getElementById('vrEnvironment');
  const currentPreset = env.getAttribute('environment').preset;
  const newPreset = currentPreset === 'starry' ? 'forest' : 'starry';
  env.setAttribute('environment', 'preset', newPreset);
  if (__LOG_INFO__) AppLog.info('Environment changed to:', newPreset);
}

function resetCamera() {
  const camera = document.getElementById('camera');
  camera.setAttribute('position', '0 1.6 3');
  camera.setAttribute('rotation', '0 0 0');
  if (__LOG_INFO__) AppLog.info('Camera reset');
}

function updateStatus(status) {
  // document.getElementById('status').textContent = status;
  if (__LOG_INFO__) AppLog.info(status);
}

function updateLastUpdate() {
  const now = new Date();
  // document.getElementById('lastUpdate').textContent = now.toLocaleTimeString();
    if (__LOG_INFO__) AppLog.info(now.toLocaleTimeString())
}

document.addEventListener('app-state-changed', function(event) {
  if (__LOG_INFO__) AppLog.info('App state changed:', event.detail);

  if (isInitialized) {
    if (__LOG_INFO__) AppLog.info('Re-running original data function due to app state change');
    setTimeout(() => {
      loadOriginalData();
    }, 100);
  }
});

window.addEventListener('error', function(event) {
  if (!event.error) return;
  if (__LOG_ERROR__) AppLog.error('Global error:', event.error);
  updateStatus('Error: ' + (event.error.message || 'Unknown error'));
});
window.addEventListener('unhandledrejection', function(event) {
  if (__LOG_ERROR__) AppLog.error('Unhandled promise rejection:', event.reason);
  const reasonMessage = event.reason ? (event.reason.message || event.reason) : 'Unknown reason';
  updateStatus('Promise error: ' + reasonMessage);
});

if (__LOG_INFO__) AppLog.info('Exact Center Panel page script loaded');


function setInitialChartType() {
  const lastChartType = getCacheItem('lastChartType') || 'topdollar';

  const sectorsState = getCacheItem(`segments_state_${lastChartType}`);
  const secondaryAction = (sectorsState && sectorsState.secondaryAction) ? sectorsState.secondaryAction : 'sec';

  if (__LOG_INFO__) AppLog.info('[A-Frame Main] Initializing chart:', lastChartType, 'with secondaryAction:', secondaryAction);

  switch (lastChartType) {
    case 'gainers':
      if (secondaryAction === 'sec') addStockGainersSectorToCenterPanel();
      else addStockGainersToCenterPanel();
      updateUI(lastChartType);
      break
    case 'losers':
      if (secondaryAction === 'sec') addStockLosersSectorToCenterPanel();
      else addStockLosersToCenterPanel();
      updateUI(lastChartType);
      break
    case 'topvol':
      if (secondaryAction === 'sec') addStockByVolCubeToCenterPanel();
      else addStockByVolRankCubeToCenterPanel();
      updateUI(lastChartType);
      break
    case 'sip':
      if (secondaryAction === 'sec') addShortInterestSectorCubeToCenterPanel();
      else addShortInterestCubeToCenterPanel();
      updateUI(lastChartType);
      break
    case 'dividend':
      if (secondaryAction === 'sec') addDividendSectorCubeToCenterPanel();
      else addDividendCubeToCenterPanel();
      updateUI(lastChartType);
      break
    case 'marketmap':
      addMarketMapCubeToCenterPanel();
      updateUI(lastChartType);
      break
    default:
      if (secondaryAction === 'sec') addStockTopDollarSectorCubeToCenterPanel();
      else addStockTopDollarCubeToCenterPanel();
      break
  }


  function updateUI(type) {
    const categoryButtons = document.querySelectorAll('#main-block .filters-container .item');
    categoryButtons.forEach(btn => {
      btn.classList.toggle('active', btn.dataset.action === type);
    });

    const playerContainer = document.querySelector('.bottom-player-area .player-container');
    const sipControlsWrapper = document.querySelector('.bottom-player-area .sip-controls-wrapper');
    const showSip = type === 'sip' || type === 'dividend';

    if (playerContainer) playerContainer.style.display = showSip ? 'none' : '';
    if (sipControlsWrapper) {
      sipControlsWrapper.style.display = showSip ? '' : 'none';
      sipControlsWrapper.classList.toggle('invisible', !showSip)
    }

    const centerPanelContainer = document.getElementById('center-panel-container');
    if (centerPanelContainer) {
      if (showSip) {
        centerPanelContainer.setAttribute('position', '0 2.45 -1.2');
      } else {
        centerPanelContainer.setAttribute('position', '0 2.7 -1.2');
      }
    }

    const sceneEl = document.querySelector('a-scene');
    const noSelectedStockMessage = document.querySelector('#no-selected-stock-message');
    const stockChart = document.getElementById('stock-chart');
    const stockWrapper = document.querySelector('#right-live-chart');
    const existingUniversal = stockChart.getAttribute('tradingview-universal-chart');
    if (!stockChart || !stockWrapper || !noSelectedStockMessage || !existingUniversal) return
    if (__LOG_INFO__) AppLog.info('ks data-interval-dividend', type);
    sceneEl.emit('data-interval-dividend', { interval: type === 'dividend' ? '1Y' : '1D' });
    if (type === 'dividend') {
      const rightAverageVolumeEl = document.querySelector('#right-average-volume');
      if (rightAverageVolumeEl) rightAverageVolumeEl.classList.remove('show')
    }


    const stockData = existingUniversal.stockData
    const ticker = JSON.parse(stockData)?.ticker || null
    if (__LOG_INFO__) AppLog.info('ks ticker', ticker, noSelectedStockMessage);
    if (ticker === 'SPY') {
      noSelectedStockMessage.classList.toggle('show', type === 'dividend');
      stockWrapper.classList.toggle('show', type !== 'dividend');
    } else {
      noSelectedStockMessage.classList.remove('show');
      stockWrapper.classList.add('show');
    }
  }


  setupSceneAutoResize();


  function setupSceneAutoResize() {
    const sceneEl = document.querySelector('a-scene');
    if (!sceneEl) return;

    ensureReady(() => {
      const ro = new ResizeObserver(() => {
        requestAnimationFrame(() => forceResize());
      });

      ro.observe(sceneEl);

      requestAnimationFrame(() => forceResize());

      sceneEl.__resizeObserver = ro;
    });

    function ensureReady(cb) {
      if (sceneEl.renderer && sceneEl.canvas) return cb();
      sceneEl.addEventListener('renderstart', cb, { once: true });
    };

    function forceResize() {
      const sceneEl = document.querySelector('a-scene');

      if (!sceneEl) return;

      if (window.StockStormDesktopScale?.resizeScene) {
        window.StockStormDesktopScale.resizeScene();
        return;
      }

      const rect = sceneEl.getBoundingClientRect();
      const width = Math.round(sceneEl.clientWidth || sceneEl.offsetWidth || rect.width || 0);
      const height = Math.round(sceneEl.clientHeight || sceneEl.offsetHeight || rect.height || 0);

      if (sceneEl.renderer && sceneEl.canvas && width > 0 && height > 0) {
        if (sceneEl.resize) sceneEl.resize();
        sceneEl.renderer.setSize(width, height, false);
        const camera = sceneEl.camera || document.getElementById('camera')?.getObject3D('camera');
        if (camera) {
          camera.aspect = width / height;
          camera.updateProjectionMatrix();
        }
        sceneEl.canvas.style.width = '100%';
        sceneEl.canvas.style.height = '100%';
        sceneEl.canvas.style.display = 'block';
        sceneEl.canvas.style.visibility = 'visible';
        window.dispatchEvent(new Event('resize'));
      }
    }
  }
}

let mainChartAutoRefresh;

document.addEventListener('DOMContentLoaded', () => {
  mainChartAutoRefresh = new window.AutoRefreshScheduler({
    name: 'MainChart',
    onRefresh: () => {
      const lastChartType = typeof getCacheItem !== 'undefined' ? (getCacheItem('lastChartType') || 'topdollar') : 'topdollar';
      const isExcluded = ['sip', 'dividend'].includes(lastChartType);
      const isWatchlistMode = document.body.classList.contains('watchlist-mode');

      if (isWatchlistMode) {
        if (window.WatchlistApp && window.WatchlistApp.Manager && window.WatchlistApp.State) {
          const state = window.WatchlistApp.State;
          if (state.currentUserId && state.currentWatchlistId) {
            window.WatchlistApp.Manager.loadWatchlistData(state.currentUserId, state.currentWatchlistId, [], null, true, false);
          }
        }
      } else if (!isExcluded) {
        refreshData();
      }
    }
  });

  mainChartAutoRefresh.start();
});